(() => {
  const queue = [];
  let flushTimer = null;
  let flushAttempts = 0;

  const getPageType = () => {
    const match = Array.from(document.body?.classList || []).find((name) => name.startsWith('lx-template--'));
    return match ? match.replace('lx-template--', '') : '';
  };

  const basePayload = () => ({
    tracking_version: '1.0',
    page_type: getPageType(),
    page_path: window.location.pathname,
    locale: document.documentElement.lang || ''
  });

  const analyticsReady = () => Boolean(window.Shopify?.analytics && typeof window.Shopify.analytics.publish === 'function');

  const publishNow = (eventName, data) => {
    try {
      const result = window.Shopify.analytics.publish(eventName, { ...basePayload(), ...data });
      if (result && typeof result.catch === 'function') result.catch(() => {});
      return true;
    } catch (_) {
      return false;
    }
  };

  const flushQueue = () => {
    flushTimer = null;
    if (!analyticsReady()) {
      flushAttempts += 1;
      if (queue.length && flushAttempts < 40) {
        flushTimer = window.setTimeout(flushQueue, 250);
      } else {
        queue.length = 0;
      }
      return;
    }

    flushAttempts = 0;
    while (queue.length) {
      const item = queue.shift();
      publishNow(item.eventName, item.data);
    }
  };

  const publish = (eventName, data = {}) => {
    if (analyticsReady()) {
      publishNow(eventName, data);
      return;
    }

    if (queue.length < 20) queue.push({ eventName, data });
    if (!flushTimer) flushTimer = window.setTimeout(flushQueue, 250);
  };

  const linkText = (anchor) => (anchor.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100);

  const isWhatsApp = (href) => /^https?:\/\/(?:wa\.me|api\.whatsapp\.com|www\.whatsapp\.com)\//i.test(href);

  const isDirections = (href) => {
    try {
      const url = new URL(href, window.location.href);
      const host = url.hostname.toLowerCase();
      const path = url.pathname.toLowerCase();
      const isGoogle = host === 'maps.google.com' || host === 'www.google.com' || host.endsWith('.google.com');
      const isApple = host === 'maps.apple.com';

      if (isGoogle && (path.includes('/maps/dir') || (url.searchParams.get('api') === '1' && url.searchParams.has('destination')))) return true;
      if (isApple && url.searchParams.has('daddr')) return true;
    } catch (_) {}
    return false;
  };

  const safeSearchQuery = (value) => {
    const clean = String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').replace(/\s+/g, ' ').trim().slice(0, 120);
    if (!clean) return '';
    if (/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(clean)) return '[redacted]';
    if ((clean.match(/\d/g) || []).length >= 7) return '[redacted]';
    return clean;
  };

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor) return;

    const rawHref = (anchor.getAttribute('href') || '').trim();
    const absoluteHref = anchor.href || rawHref;
    const common = { link_text: linkText(anchor) };

    if (isWhatsApp(absoluteHref)) {
      publish('hce_whatsapp_click', common);
      return;
    }

    if (/^tel:/i.test(rawHref)) {
      publish('hce_phone_click', common);
      return;
    }

    if (isDirections(absoluteHref)) {
      publish('hce_directions_click', common);
    }
  }, true);

  const publishZeroResultSearch = () => {
    if (getPageType() !== 'search') return;

    const params = new URLSearchParams(window.location.search);
    const rawQuery = params.get('q');
    if (!rawQuery || !document.querySelector('.template-search--empty')) return;

    const query = safeSearchQuery(rawQuery);
    publish('hce_zero_result_search', {
      query,
      query_length: String(rawQuery).trim().length,
      result_count: 0
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', publishZeroResultSearch, { once: true });
  } else {
    publishZeroResultSearch();
  }
})();